import { get } from "../api.js";

/**
 * The appointment's exact Amelia tutor/service pair, read from the Hub mirror.
 *
 * These values are inputs to the authoritative availability read only. They are
 * never treated as permission to move the appointment; preview and mutation
 * remain server-authoritative and target the existing appointment id.
 */
export interface RescheduleContext {
  provider_id: number;
  service_id: number;
}

export function getRescheduleContext(bookingId: string): Promise<RescheduleContext> {
  return get<RescheduleContext>(
    `/admin/bookings/${encodeURIComponent(bookingId)}/reschedule-context`,
  );
}
